<template>
    <!--
				Card - Blog
    -->
    <div class="card-inner blog" :class="{'active':$route.name=='Blog'}" id="blog-card">
        <div class="card-wrap">
            <!--
						Blog
            -->
            <div class="content blog">
                <!-- title -->
                <div class="title">
                    {{$t("blog.001")}}
                    <span class="subtitle fz-rem5">{{$t("blog.002")}}</span>
                </div>

                <!-- content -->

                <div class="row border-line-v">
                    <!-- blog item -->
                    <template v-for="(item, index) in blogList">
                        <div :key="index" class="col col-d-12 col-t-12 col-m-12 border-line-h">
                            <div class="box-item">
                                <div class="image">
                                    <a :href="item.link" target="_blank">
                                        <img :src="require('@/assets/images/blog/'+item.img)" alt />
                                        <span class="info">
                                            <span class="fas fa-link"></span>
                                        </span>
                                        <span class="date">
                                            <strong v-text="item.year"></strong>
                                            <span v-text="item.month"></span>
                                        </span>
                                    </a>
                                </div>
                                <div class="desc">
                                    <a :href="item.link" target="_blank" class="name" v-text="item.des"></a>
                                    <div class="category" v-text="item.type"></div>
                                </div>
                            </div>
                        </div>
                    </template>

                    <div class="clear"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        blogList() {
            return [
                {
                    month: this.$t("blog.012"),
                    year: "2019",
                    img: "modernWeb19.jpg",
                    des: "Modern Web 2019",
                    type: this.$t("blog.003"),
                    link: "https://modernweb.tw/"
                },
                {
                    month: this.$t("blog.013"),
                    year: "2019",
                    img: "yushin.jpg",
                    des: this.$t("blog.004"),
                    type: this.$t("blog.005"),
                    link: "https://www.instagram.com/p/B0QSm9clqI4/"
                },
                {
                    month: this.$t("blog.014"),
                    year: "2019",
                    img: "cheer.jpg",
                    des: this.$t("blog.006"),
                    type: this.$t("blog.007"),
                    link: "https://www.facebook.com/photo.php?fbid=2379702518715981&set=a.830604443625804&type=3&theater"
                },
                {
                    month: this.$t("blog.015"),
                    year: "2018",
                    img: "ithelp.jpg",
                    des: this.$t("blog.008"),
                    type: this.$t("blog.009"),
                    link: "https://ithelp.ithome.com.tw/users/20107585/ironman/1602"
                },
                {
                    month: this.$t("blog.016"),
                    year: "2018",
                    img: "hacker.jpg",
                    des: this.$t("blog.010"),
                    type: this.$t("blog.011"),
                    link: "https://smartcityhackathon2018.alysida.io/"
                }
            ];
        }
    }
};
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/Blog.vue